import React, { memo, useState, useCallback, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import LottieComponent from '@components/Lottie';
import { useCurrentWorkspace } from '@hooks/workspace';

import {
  useGetCountApprovalWorkflows,
  useGetListApprovalWorkflows
} from '@hooks/queries/approval';
import DashboardApprovalsFilter from '@pages/Dashboard/components/DashboardFilter/DashboardApprovalsFilter';
import ApprovalsList from '@pages/Dashboard/components/ApprovalsCard/ApprovalsList';

import './ApprovalsCard.less';

export default memo(function ApprovalsCard() {
  const [currentWorkspace] = useCurrentWorkspace(false);
  const [listType, setListType] = useState<'all' | 'assigned' | 'own'>('all');

  const params = {
    workspaceId: currentWorkspace?.id || '',
    needMyDecision: listType === 'assigned' ? true : undefined,
    own: listType === 'own' ? true : undefined,
    my: listType === 'all' ? true : undefined
  };

  const { data: approvalsCount, isLoading: isLoadingApprovalsCount } =
    useGetCountApprovalWorkflows({
      params
    });

  const {
    data: approvals,
    isLoading: isLoadingApprovals,
    hasNextPage: hasNextPageApprovals,
    refetch: refetchApprovals,
    fetchNextPage: fetchNextPageApprovals
  } = useGetListApprovalWorkflows({
    params
  });

  const approvalsList = useMemo(
    () => approvals?.pages.flatMap((x) => x.edges.map((x) => x.node)) ?? [],
    [approvals]
  );

  const isLoading = isLoadingApprovals || isLoadingApprovalsCount;

  const onApprovalsFilterChange = useCallback(
    (v: 'all' | 'assigned' | 'own') => setListType(v),
    []
  );

  return (
    <div className="card_container">
      <div className="card_container__header">
        <span className="copy">
          <LottieComponent className="icon" isLooped={false} view="star" />
          MY APPROVALS
          <div className="count">{approvalsCount}</div>
        </span>
        <DashboardApprovalsFilter
          listType={listType}
          onFilterChange={onApprovalsFilterChange}
        />
      </div>
      <OverlayScrollbarsComponent>
        <div className="card_container__body">
          <div className="approval-container" id="approval-container">
            <InfiniteScroll
              dataLength={approvalsList?.length || 0}
              hasMore={!!hasNextPageApprovals}
              next={fetchNextPageApprovals}
              loader={<></>}
            >
              <ApprovalsList
                list={approvalsList}
                refetchApprovalsData={refetchApprovals}
                isLoading={isLoading}
              />
            </InfiniteScroll>
          </div>
        </div>
      </OverlayScrollbarsComponent>
    </div>
  );
});
